import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import {Link as LinkR} from 'react-router-dom'
import {Link as LinkS} from 'react-scroll'

export const SidebarContainer = styled.aside`
    position: fixed;
    z-index: 999;
    width: 60%;
    height: 100%;
    background: #202020;
    display: grid;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    transition: 0.3s all ease-in-out;
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};

`

export const CloseIcon = styled(FaTimes)`
    color: #fff;

`

export const Icon = styled.div`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    font-size: 1.4rem;
    cursor: pointer;
    outline: none;

`
export const SidebarWrapper = styled.div`
    color: #fff;

`

export const SidebarMenu = styled.ul`
    padding: 0;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(12, 40px);
    text-align: center;

    @media screen and (max-width: 480px) {
        grid-template-rows: repeat(12, 40px);
    }

`

export const SidebarLink = styled(LinkS)`
    display: flex;
    align-items: center;
    justify-content: flex-start; 
    font-size: 1rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s all ease-in-out;
    color: #fff;
    cursor: pointer;
    padding: 10px 20px; 
    margin: 0;
    gap: 10px; 

    &:hover {
        color: #8BC34A;
        transition: 0.2s all ease-in-out;
    }
`;


export const SideBtnWrap = styled.button`
 display: flex;
align-items: center;
justify-content: flex-start;
font-size: 1rem;
text-decoration: none;
list-style: none;
transition: 0.2s all ease-in-out;
color: #fff;
cursor: pointer;
padding: 10px 20px; 
 margin: 0;
gap: 10px; 
background-color: transparent; /* Corrected the typo here */
border: none; /* Optional: To remove any border */
&:hover {
  color: #8BC34A;
  transition: 0.2s all ease-in-out;
}
`

export const SidebarRoute = styled(LinkR)`
    display: flex;
    align-items: center;
    justify-content: flex-start; 
    font-size: 1rem;
    text-decoration: none;
    list-style: none;
    transition: 0.2s all ease-in-out;
    color: #fff;
    cursor: pointer;
    padding: 10px 20px; 
    margin: 0;
    gap: 10px; 
    &:hover {
        color: #8BC34A;
        transition: 0.2s all ease-in-out;
    }

`